
import React from 'react';

export const BrandLogo: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      viewBox="0 0 1000 1000"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby="logoTitle logoDesc"
    >
      <title id="logoTitle">StoryForge Kids Logo</title>
      <desc id="logoDesc">A magical book opening on a golden anvil, symbolizing the forging of personalized children's stories.</desc>
      <defs>
        {/* The Gold-to-Orange gradient for the frame and anvil structure */}
        <linearGradient id="logoGoldGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#DEA01E" />
          <stop offset="100%" stopColor="#FF7F1A" />
        </linearGradient>
        
        {/* The Magical Page/Flame gradient: Gold -> Orange -> Purple */}
        <linearGradient id="magicPetalGradient" x1="0%" y1="100%" x2="0%" y2="0%">
          <stop offset="0%" stopColor="#DEA01E" />
          <stop offset="40%" stopColor="#FF7F1A" />
          <stop offset="100%" stopColor="#7F5AF0" />
        </linearGradient>

        <filter id="magicGlow" x="-30%" y="-30%" width="160%" height="160%">
          <feGaussianBlur stdDeviation="20" result="blur" />
          <feComposite in="SourceGraphic" in2="blur" operator="over" />
        </filter>
      </defs>

      {/* OUTER CIRCULAR FRAME */}
      <circle
        cx="500"
        cy="500"
        r="440"
        stroke="url(#logoGoldGradient)"
        strokeWidth="10"
        opacity="0.8"
      />

      {/* ANVIL BASE (The Forge) */}
      <path
        d="M340 650 L660 650 C660 650 660 750 600 770 C560 785 560 810 560 850 L440 850 C440 810 440 785 400 770 C340 750 340 650 340 650Z"
        fill="#1A1825"
        stroke="url(#logoGoldGradient)"
        strokeWidth="8"
        strokeLinejoin="round"
      />
      <path
        d="M340 650 L260 650 C260 650 270 700 350 720 L350 650 Z"
        fill="#1A1825"
        stroke="url(#logoGoldGradient)"
        strokeWidth="8"
        strokeLinejoin="round"
      />

      {/* THE OPEN BOOK SPINE & BASE PAGES */}
      <path
        d="M500 640 L300 640 C300 640 310 610 500 610 L500 640 Z"
        fill="url(#logoGoldGradient)"
        opacity="0.9"
      />
      <path
        d="M500 640 L700 640 C700 640 690 610 500 610 L500 640 Z"
        fill="url(#logoGoldGradient)"
        opacity="0.9"
      />

      {/* FLUTTERING PAGES (The "Flower Petal" arrangement) */}
      <g filter="url(#magicGlow)">
        {/* Outer Left Petal (Page) */}
        <path
          d="M500 610 C420 600 320 540 340 440 C380 500 440 580 500 610Z"
          fill="url(#magicPetalGradient)"
          opacity="0.7"
        />
        {/* Outer Right Petal (Page) */}
        <path
          d="M500 610 C580 600 680 540 660 440 C620 500 560 580 500 610Z"
          fill="url(#magicPetalGradient)"
          opacity="0.7"
        />
        
        {/* Mid Left Petal */}
        <path
          d="M500 610 C460 580 380 500 420 360 C460 440 480 550 500 610Z"
          fill="url(#magicPetalGradient)"
          opacity="0.85"
        />
        {/* Mid Right Petal */}
        <path
          d="M500 610 C540 580 620 500 580 360 C540 440 520 550 500 610Z"
          fill="url(#magicPetalGradient)"
          opacity="0.85"
        />

        {/* Center Fluttering Page (Core Petal) */}
        <path
          d="M500 610 C470 520 450 380 500 240 C550 380 530 520 500 610Z"
          fill="url(#magicPetalGradient)"
        />

        {/* Small Inner Fluttering Pages */}
        <path
          d="M500 610 C490 580 470 540 500 480 C530 540 510 580 500 610Z"
          fill="#DEA01E"
          opacity="0.6"
        />
      </g>

      {/* MAGICAL SPARKS & FLOATING MOTIFS */}
      <g>
        {/* Large Star at Apex */}
        <path d="M500 160 L510 190 L540 200 L510 210 L500 240 L490 210 L460 200 L490 190 Z" fill="#7F5AF0" />
        
        {/* Floating Sparks */}
        <circle cx="420" cy="300" r="8" fill="#DEA01E" />
        <circle cx="580" cy="300" r="8" fill="#FF7F1A" />
        <circle cx="500" cy="350" r="6" fill="#7F5AF0" opacity="0.6" />
        
        {/* Tiny Cross Sparks */}
        <path d="M380 480 L385 495 L400 500 L385 505 L380 520 L375 505 L360 500 L375 495 Z" fill="#FF7F1A" />
        <path d="M620 480 L625 495 L640 500 L625 505 L620 520 L615 505 L600 500 L615 495 Z" fill="#DEA01E" />
      </g>
    </svg>
  );
};
